import kaplay from "kaplay";

export const k = kaplay({
  width: 640,
  height: 853,
  pixelDensity: 3,
  letterbox: true,
  font: "regular",
  global: false,
  background: [0, 108, 50]
});

